var map = {
	"./file-extension/7zip.svg": "fRn3",
	"./file-extension/ace.svg": "NdB5",
	"./file-extension/aep.svg": "DGje",
	"./file-extension/aepx.svg": "a1gv",
	"./file-extension/aet.svg": "nmV9",
	"./file-extension/ai.svg": "IhI5",
	"./file-extension/ait.svg": "mL3Q",
	"./file-extension/avi.svg": "0trh",
	"./file-extension/bmp.svg": "EQ5F",
	"./file-extension/c.svg": "S1z8",
	"./file-extension/css.svg": "VlmH",
	"./file-extension/default.svg": "P6eO",
	"./file-extension/doc.svg": "87V6",
	"./file-extension/docx.svg": "YsZU",
	"./file-extension/dotx.svg": "RdWJ",
	"./file-extension/eps.svg": "P9Sk",
	"./file-extension/flv.svg": "b4gH",
	"./file-extension/folder.svg": "+3wV",
	"./file-extension/gif.svg": "UEtg",
	"./file-extension/html.svg": "2bCH",
	"./file-extension/java.svg": "9OOe",
	"./file-extension/jpeg.svg": "l25/",
	"./file-extension/jpg.svg": "AnJn",
	"./file-extension/js.svg": "5yVJ",
	"./file-extension/less.svg": "QHSQ",
	"./file-extension/m4a.svg": "puWN",
	"./file-extension/mid.svg": "g13m",
	"./file-extension/mp3.svg": "9Qq+",
	"./file-extension/mp4.svg": "DCZ3",
	"./file-extension/mpg.svg": "TC6a",
	"./file-extension/odf.svg": "y27C",
	"./file-extension/ods.svg": "68u7",
	"./file-extension/odt.svg": "TF4Q",
	"./file-extension/otp.svg": "0MRO",
	"./file-extension/ots.svg": "zPnj",
	"./file-extension/ott.svg": "GuHM",
	"./file-extension/pdf.svg": "vJPJ",
	"./file-extension/php.svg": "9Cwv",
	"./file-extension/png.svg": "9B0N",
	"./file-extension/ppt.svg": "PU7y",
	"./file-extension/pptx.svg": "y9fQ",
	"./file-extension/psd.svg": "towO",
	"./file-extension/py.svg": "2uoG",
	"./file-extension/qt.svg": "OfVB",
	"./file-extension/rar.svg": "T21/",
	"./file-extension/raw.svg": "7I9g",
	"./file-extension/svg.svg": "XRvl",
	"./file-extension/tga.svg": "mfBx",
	"./file-extension/tgz.svg": "Gj80",
	"./file-extension/txt.svg": "XVmE",
	"./file-extension/wav.svg": "NNBq",
	"./file-extension/xls.svg": "UYX7",
	"./file-extension/xlsx.svg": "K5FQ",
	"./file-extension/xml.svg": "4mZd",
	"./file-extension/zip.svg": "FOAf",
	"./font-awesome/angle-right-regular.svg": "Akdl",
	"./font-awesome/arrow-to-bottom-light.svg": "jxz3",
	"./font-awesome/bars-regular.svg": "DLJq",
	"./font-awesome/bell-regular.svg": "nJ2T",
	"./font-awesome/check-circle-light.svg": "pYp/",
	"./font-awesome/check-circle-solid.svg": "McbU",
	"./font-awesome/chevron-down-solid.svg": "bjgA",
	"./font-awesome/chevron-left-regular.svg": "N5hs",
	"./font-awesome/chevron-right-solid.svg": "X42H",
	"./font-awesome/circle-solid.svg": "MRbq",
	"./font-awesome/cloud-upload-light.svg": "ftKK",
	"./font-awesome/cog-duotone.svg": "po9T",
	"./font-awesome/cog-regular.svg": "Gdu9",
	"./font-awesome/comments-alt-regular.svg": "VORU",
	"./font-awesome/edit-regular.svg": "QO+3",
	"./font-awesome/envelope-solid.svg": "xIkk",
	"./font-awesome/exclamation-triangle-duotone.svg": "eGzo",
	"./font-awesome/exclamation-triangle-light.svg": "Enoc",
	"./font-awesome/eye-dropper-solid.svg": "c98R",
	"./font-awesome/fa-downloand.svg": "syWB",
	"./font-awesome/filter-regular.svg": "Ej3T",
	"./font-awesome/fingerprint-duotone.svg": "5MME",
	"./font-awesome/hashtag.svg": "J3X8",
	"./font-awesome/id-card-duotone.svg": "/xqQ",
	"./font-awesome/id-card-regular.svg": "XlA/",
	"./font-awesome/inbox-out-duotone.svg": "3CNd",
	"./font-awesome/inbox-regular.svg": "1ZSv",
	"./font-awesome/info-circle-light.svg": "jhwu",
	"./font-awesome/keyboard-duotone.svg": "Efvu",
	"./font-awesome/language-duotone.svg": "GNpf",
	"./font-awesome/language-regular.svg": "sDuM",
	"./font-awesome/lock-alt-regular.svg": "jxDA",
	"./font-awesome/lock-open-alt-solid.svg": "Bc3s",
	"./font-awesome/pennant-regular.svg": "jUaI",
	"./font-awesome/reply-regular.svg": "U+X9",
	"./font-awesome/robot-duotone.svg": "88UO",
	"./font-awesome/search-duotone.svg": "ysB5",
	"./font-awesome/search-regular.svg": "L4ag",
	"./font-awesome/share-alt-solid.svg": "e7cr",
	"./font-awesome/sort-amount-down-alt-regular.svg": "uHlF",
	"./font-awesome/sort-amount-up-alt-regular.svg": "YEXO",
	"./font-awesome/supervidor-regular.svg": "kiaz",
	"./font-awesome/swatchbook-duotone.svg": "pJvl",
	"./font-awesome/sync-regular.svg": "5LNR",
	"./font-awesome/tachometer-alt-regular.svg": "wLhX",
	"./font-awesome/tags-regular.svg": "57us",
	"./font-awesome/tasks-regular.svg": "Zdps",
	"./font-awesome/times-circle-light.svg": "exkQ",
	"./font-awesome/times-circle-solid.svg": "7+7n",
	"./font-awesome/times-light.svg": "oh00",
	"./font-awesome/times-solid.svg": "E9q1",
	"./font-awesome/trash-alt-regular.svg": "QX48",
	"./font-awesome/user-tag-regular.svg": "VxCG",
	"./font-awesome/users-class-regular.svg": "fl0O",
	"./font-awesome/users-duotone.svg": "IZCJ",
	"./font-awesome/users-regular.svg": "Lywi",
	"./undraw/browsing.svg": "RaQ8",
	"./undraw/page-not-found.svg": "jn4Z",
	"./undraw/task-list.svg": "IFOJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TPdo";